import {
  NotificationRecipientUpdate,
  NotificationResponse,
  NotificationRowResponse,
} from "@cnx/common";
import api from "services/api";
import { getLangParam } from "utils/index";

class NotificationService {
  static async getNotifications(): Promise<NotificationResponse> {
    const { data } = await api.get<NotificationResponse>("/notifications", {
      params: { lang: getLangParam() },
    });
    return data;
  }
  static async getChanges(
    notificationId: string
  ): Promise<NotificationRowResponse> {
    const { data } = await api.get<NotificationRowResponse>(
      `/notification-rows/${notificationId}`,
      {
        params: { lang: getLangParam() },
      }
    );
    return data;
  }
  static async updateNotificationRecipient(
    notificationId: string,
    update: NotificationRecipientUpdate
  ) {
    return api.patch(`/notification-recipient/${notificationId}`, update);
  }

  static async archiveNotification(notificationId: string) {
    return api.patch(`/notification-archive/${notificationId}`);
  }
}

export default NotificationService;
